import './loading.css';

export const Loading = () => (
  <div className="overlay">
    <div className="popup-spinner">
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
);